import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import OrderTracking from './OrderTracking';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/:orderId" element={<OrderTracking />} />
        <Route path="/:orderId/:key" element={<OrderTracking/>} />
      </Routes>
    </Router>
  );
}

export default App;
